export const SET_PAGE_TEMPLATES = 'page-templates/set-page-templates';
export const SET_PAGE_TEMPLATES_TOTAL = 'page-templates/set-page-templates-total';
export const SET_SELECTED_PAGE_TEMPLATE = 'page-templates/set-selected-page-template';
export const REMOVE_SELECTED_PAGE_TEMPLATE = 'page-templates/remove-selected-page-template';
export const REMOVE_PAGE_TEMPLATE = 'page-templates/remove-page-template';
export const SET_SELECTED_PAGE_TEMPLATE_PAGE_REFS = 'page-templates/set-selected-page-template-page-refs';
